// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/loader-white.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .edit-menu {
  padding: 50px 20px 20px 20px;
}
.popup .edit-menu h2 {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .edit-menu form {
  margin-top: 4%;
}
.popup .edit-menu form .error {
  font: 1.2em/1 vigaregular;
  color: #000;
  padding-top: 2%;
  padding-bottom: 2%;
}
.popup .edit-menu form input[type=text] {
  background-color: #f5f5f5;
  width: 100%;
  border-radius: 6px;
  outline: none;
  padding: 7% 0% 7% 5%;
  border: 0;
  box-sizing: border-box;
  font: 1.4em/1 vigaregular;
}
.popup .edit-menu form input[type=file] {
  overflow: hidden;
  height: 0;
  display: none;
}
.popup .edit-menu .button-logo {
  text-decoration: none;
  text-align: center;
  border: 2px solid #caa36c;
  border-radius: 5px;
  padding: 4% 0 4%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.popup .edit-menu .button-logo span {
  font: 1.4em/1 vigaregular;
  color: #caa36c;
}
.popup .edit-menu .button-logo span:last-child {
  margin-top: 2%;
  font: 1.1em/1 vigaregular;
  color: #caa36c;
}
.popup .edit-menu .button-logo .remove {
  transform: translateY(-50%);
  position: absolute;
  width: 20px;
  right: 10px;
  top: 50%;
}
.popup .edit-menu .button-logo .remove img {
  width: 100%;
}
.popup .edit-menu .button-logo.upload {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}
.popup .edit-menu .button-logo.upload span {
  visibility: hidden;
}
.popup .edit-menu .button-image a {
  text-decoration: none;
  text-align: center;
  border: 2px solid #caa36c;
  border-radius: 5px;
  padding: 4% 0 4%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.popup .edit-menu .button-image a span {
  font: 1.7em/1 vigaregular;
  color: #caa36c;
}
.popup .edit-menu .row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*height: 8vh;*/
}
.popup .edit-menu .row .label {
  flex: 1 1;
  min-width: 45%;
}
.popup .edit-menu .row .label h2 {
  font-size: 1.4em;
  line-height: 1.2em;
  padding-right: 10px;
}
.popup .edit-menu .language {
  margin-top: 16%;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/AddMenuContent.scss"],"names":[],"mappings":"AACI;EACI,4BAAA;AAAR;AAEQ;EACI,uBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,cAAA;AADZ;AAGY;EACI,yBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AADhB;AAIY;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EAEA,SAAA;EACA,sBAAA;EACA,yBAAA;AAHhB;AAMY;EACI,gBAAA;EACA,SAAA;EACA,aAAA;AAJhB;AAQQ;EACI,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AANZ;AAOY;EACI,yBAAA;EACA,cAAA;AALhB;AAOgB;EACI,cAAA;EACA,yBAAA;EACA,cAAA;AALpB;AASY;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;AAPhB;AASgB;EACI,WAAA;AAPpB;AAWY;EACI,2EAAA;AAThB;AAWgB;EACI,kBAAA;AATpB;AAeY;EACI,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAbhB;AAegB;EACI,yBAAA;EACA,cAAA;AAbpB;AAkBQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAhBZ;AAkBY;EACI,SAAA;EACA,cAAA;AAhBhB;AAkBgB;EACI,gBAAA;EACA,kBAAA;EACA,mBAAA;AAhBpB;AAqBQ;EACI,eAAA;AAnBZ","sourcesContent":[".popup {\n    .edit-menu {\n        padding: 50px 20px 20px 20px;\n\n        h2 {\n            font: 2em/1 vigaregular;\n            color: #5c5c5c;\n        }\n\n        form {\n            margin-top: 4%;\n\n            .error {\n                font: 1.2em/1 vigaregular;\n                color: #000;\n                padding-top: 2%;\n                padding-bottom: 2%;\n            }\n\n            input[type=\"text\"] {\n                background-color: #f5f5f5;\n                width: 100%;\n                border-radius: 6px;\n                outline: none;\n                padding: 7% 0% 7% 5%;\n                // margin: 0px;\n                border: 0;\n                box-sizing: border-box;\n                font: 1.4em/1 vigaregular;\n            }\n\n            input[type=\"file\"] {\n                overflow: hidden;\n                height: 0;\n                display: none;\n            }\n        }\n\n        .button-logo {\n            text-decoration: none;\n            text-align: center;\n            border: 2px solid #caa36c;\n            border-radius: 5px;\n            padding: 4% 0 4%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            flex-direction: column;\n            span {\n                font: 1.4em/1 vigaregular;\n                color:#caa36c;\n\n                &:last-child {\n                    margin-top: 2%;\n                    font: 1.1em/1 vigaregular;\n                    color: #caa36c;\n                }\n            }\n\n            .remove {\n                transform: translateY(-50%);\n                position: absolute;\n                width: 20px;\n                right: 10px;\n                top: 50%;\n                \n                img {\n                    width: 100%;\n                }\n            }\n\n            &.upload {\n                background: url(../../../../public/images/loader-white.gif) no-repeat center center;\n\n                span {\n                    visibility: hidden;\n                }\n            }\n        }\n\n        .button-image {\n            a {\n                text-decoration: none;\n                text-align: center;\n                border: 2px solid #caa36c;\n                border-radius: 5px;\n                padding: 4% 0 4%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                flex-direction: column;\n\n                span {\n                    font: 1.7em/1 vigaregular;\n                    color: #caa36c;\n                }\n            }\n        }\n\n        .row {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            /*height: 8vh;*/\n\n            .label {\n                flex: 1;\n                min-width: 45%;\n\n                h2 {\n                    font-size: 1.4em;\n                    line-height: 1.2em;\n                    padding-right: 10px;\n                }\n            }\n        }\n\n        .language {\n            margin-top: 16%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
